/**
 * storage二次封装,本地存储(密钥，键，键值)
 */
import { isNull } from "./utils";

/**
 * 获取密钥
 */
function getStroage(type: string, namespace: string) {
  if (type === "local") {
    return JSON.parse(window.localStorage.getItem(namespace) || "{}");
  } else {
    return JSON.parse(window.sessionStorage.getItem(namespace) || "{}");
  }
}
/**
 * 写入值
 */
function setItem(type: string, namespace: string, key: string, val: any) {
  const res = getStroage(type, namespace);
  res[key] = val;
  if (type === "local") {
    window.localStorage.setItem(namespace, JSON.stringify(res));
  } else {
    window.sessionStorage.setItem(namespace, JSON.stringify(res));
  }
}
/**
 * 获取值
 */
function getItem(type: string, namespace: string, key: string) {
  try {
    return getStroage(type, namespace)[key];
  } catch {
    return "";
  }
}
/**
 * 清除值
 */
function clearItem(type: string, namespace: string, key: string) {
  const res = getStroage(type, namespace);
  delete res[key];
  if (type === "local") {
    window.localStorage.setItem(namespace, JSON.stringify(res));
  } else {
    window.sessionStorage.setItem(namespace, JSON.stringify(res));
  }
}
/**
 * 清除密钥
 */
function clearNamespace(type: string, namespace: string) {
  if (type === "local") {
    window.localStorage.removeItem(namespace);
  } else {
    window.sessionStorage.removeItem(namespace);
  }
}
/**
 * 清除所有
 */
function clearAll(type: string) {
  if (type === "local") {
    window.localStorage.clear();
  } else {
    window.sessionStorage.clear();
  }
}

/**
 * -------------------------------------------------
 */

/**
 * 获取序列号
 */
function getSerialNo() {
  try {
    return getItem("local", "c", "qp_serial");
  } catch (e) {
    return "";
  }
}

/**
 * 存放栏目Id
 */
function setNodeId(nodeId: string) {
  setItem("session", "basic", "nodeid", nodeId);
}
/**
 * 获取栏目Id
 */
function getNodeId() {
  try {
    return getItem("session", "basic", "nodeid");
  } catch (e) {
    return "";
  }
}
/**
 * 清空栏目Id
 */
function clearNodeId() {
  setItem("session", "basic", "nodeid", "");
}

/**
 * 清空用户权限
 */
function clearUserRight() {
  setItem("session", "basic", "userright", "");
}

/**
 * 获取页面栏目
 */
function getPageNode(nodeId: string) {
  try {
    const userNodeList = getItem("session", "basic", "node");
    const arr = userNodeList.filter((val: any) => {
      return val.parentId === nodeId;
    }) as any;

    return arr;
  } catch (e) {
    return "";
  }
}

/**
 * 存放二级页面栏目路由
 */
function setPageNodePath(parentId: string, nodePath: string) {
  setItem("session", "pagenode", parentId, nodePath);
}
/**
 * 获取二级页面栏目路由
 */
function getPageNodePath(parentId: string) {
  try {
    const res = getItem("session", "pagenode", parentId);
    return res;
  } catch (e) {
    return "";
  }
}

/**
 * 存放父级页面路由
 */
function setParentNodePath(nodeKey: string, nodePath: string) {
  setItem("session", "parentnode", nodeKey, nodePath);
}
/**
 * 获取父级页面路由
 */
function getParentNodePath(nodeKey: string) {
  try {
    const res = getItem("session", "parentnode", nodeKey);
    return res;
  } catch (e) {
    return "";
  }
}

/**
 * 获取用户权限
 */
function getUserRight(nodeId: string) {
  try {
    const userNodeList = getItem("session", "basic", "node");
    const arr = userNodeList.filter((val: any) => {
      return val.nodeId === nodeId;
    })[0] as any;

    setItem("session", "basic", "userright", arr.userRight);

    return arr.userRight;
  } catch (e) {
    return "";
  }
}
/**
 * 存放用户权限
 */
function setUserRight(nodeId: string) {
  try {
    const userNodeList = getItem("session", "basic", "node");
    const arr = userNodeList.filter((val: any) => {
      return val.nodeId === nodeId;
    })[0] as any;

    setItem("session", "basic", "userright", arr.userRight);
  } catch (e) {
    return false;
  }
}
/**
 * 获取操作权限
 */
function getOperateRight(val: string) {
  try {
    if (getItem("session", "basic", "userright").indexOf(val) >= 0) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
}
/**
 * 检验操作权限
 */
function inspectUserRight(userRight: string, val: string) {
  try {
    if (userRight.indexOf(val) >= 0) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
}

/**站点*/

/**
 * 获取-站点绑定--不用代码
 */
function getPlaceBindByClassAndLongFlag(bindClass: number,bindLongFlag:number) {
  try {
    const userPlaceList = getItem("session", "basic", "placebind");
    /**class（1-出发；2-到达) longflag(0-否;1-是) */
    const arr = userPlaceList.filter((val: any) => {
      return val.placeBindClass === bindClass && val.placeBindLongFlag === bindLongFlag;
    }) as any;

    // /**出发*/
    // if (bindClass === 1) {
    //   arr = userPlaceList.filter((val: any) => {
    //     return val.placeBindClass === 1;
    //   }) as any;
    // }
    // /**到达*/
    // if (bindClass === 2) {
    //   arr = userPlaceList.filter((val: any) => {
    //     return val.placeBindClass === 2;
    //   }) as any;
    // }

    arr.unshift({ placeId: "-1", placeName: "请选择" });

    return arr;
  } catch (e) {
    return [{ placeId: "-1", placeName: "无站点" }] as any;
  }
}
/**
 * 获取-站点绑定-不含请选择-不用代码
 */
function getPlaceBindByClassAndLongFlagNoPlease(bindClass: number,bindLongFlag:number) {
  try {
    const userPlaceList = getItem("session", "basic", "placebind");
    /**class（1-出发；2-到达) longflag(0-否;1-是) */
    const arr = userPlaceList.filter((val: any) => {
      return val.placeBindClass === bindClass && val.placeBindLongFlag === bindLongFlag;
    }) as any;

    if (arr.length <= 0) {
      return [{ placeId: "-1", placeName: "无站点" }] as any;
    } else {
      return arr;
    }
  } catch (e) {
    return [{ placeId: "-1", placeName: "无站点" }] as any;
  }
}

/**
 * 获取-站点绑定-出发
 */
function getPlaceBindStart() {
  try {
    const userPlaceList = getItem("session", "basic", "placebind");
    /**class（1-出发；2-到达)*/
    const arr = userPlaceList.filter((val: any) => {
      return val.placeBindClass === 1;
    }) as any;
    arr.unshift({ placeId: "-1", placeName: "请选择" });
    return arr;
  } catch (e) {
    return [{ placeId: "-1", placeName: "无站点" }] as any;
  }
}
/**
 * 获取-站点绑定-托单到达
 */
function getPlaceBindConsignmentArrive() {
  try {
    const userPlaceList = getItem("session", "basic", "placebind");
    /**class（1-出发；2-到达) consignmentArriveFlag(0-否;1-是) */
    const arr = userPlaceList.filter((val: any) => {
      return val.placeBindClass === 2 && val.placeBindConsignmentArriveFlag === 1;
    }) as any;
    arr.unshift({ placeId: "-1", placeName: "请选择" });
    return arr;
  } catch (e) {
    return [{ placeId: "-1", placeName: "无站点" }] as any;
  }
}
/**
 * 获取-站点绑定-干线到达
 */
function getPlaceBindLongArrive() {
  try {
    const userPlaceList = getItem("session", "basic", "placebind");
    /**class（1-出发；2-到达) consignmentLongFlag(0-否;1-是) */
    const arr = userPlaceList.filter((val: any) => {
      return val.placeBindClass === 2 && val.placeBindLongArriveFlag === 1;
    }) as any;
    arr.unshift({ placeId: "-1", placeName: "请选择" });

    return arr;
  } catch (e) {
    return [{ placeId: "-1", placeName: "无站点" }] as any;
  }
}

/**
 * 获取- 客户-站点
 */
function getMemberPlace() {
  try {
    const memberPlaceList = getItem("session", "basic", "memberplace");
    if (memberPlaceList.length <= 0) {
      return [{ placeId: "-1", placeName: "无站点" }] as any;
    } else if (memberPlaceList.length > 1) {
      memberPlaceList.unshift({ placeId: "-1", placeName: "请选择" });
    }
    return memberPlaceList;
  } catch (e) {
    return [{ placeId: "-1", placeName: "无站点" }] as any;
  }
}

/**
 * 获取-用户-操作站点
 */
function getUserOperatePlace() {
  try {
    const userPlaceList = getItem("session", "basic", "userplace");
    if (userPlaceList.length <= 0) {
      return [{ placeId: "-1", placeName: "无站点" }] as any;
    } else if (userPlaceList.length > 1) {
      userPlaceList.unshift({ placeId: "-1", placeName: "请选择" });
    }
    return userPlaceList;
  } catch (e) {
    return [{ placeId: "-1", placeName: "无站点" }] as any;
  }
}
/**
 * 获取-用户-操作站点-不含请选择
 */
function getUserOperatePlaceNoPlease() {
  try {
    const userPlaceList = getItem("session", "basic", "userplace");
    if (userPlaceList.length <= 0) {
      return [{ placeId: "-1", placeName: "无站点" }] as any;
    }
    return userPlaceList;
  } catch (e) {
    return [{ placeId: "-1", placeName: "无站点" }] as any;
  }
}
/**
 * 获取-用户-操作站点-必须请选择
 */
function getUserOperatePlaceMustPlease() {
  try {
    const userPlaceList = getItem("session", "basic", "userplace");
    userPlaceList.unshift({ placeId: "-1", placeName: "请选择" });
    return userPlaceList;
  } catch (e) {
    return [{ placeId: "-1", placeName: "无站点" }] as any;
  }
}

/**
 * 获取-站点地区（根据站点Id）
 */
function getPlaceRegion(placeId: string) {
  try {
    const userPlaceList = getItem("session", "basic", "memberplace");
    const arr = userPlaceList.filter((val: any) => {
      return val.placeId === placeId;
    }) as any;

    if (isNull(arr) === true) {
      return "";
    } else {
      return arr[0].placeRegion;
    }
  } catch (e) {
    return "";
  }
}

/**
 * 获取-站点名称（根据站点Id）
 */
function getPlaceName(placeId: string) {
  try {
    const userPlaceList = getItem("session", "basic", "basicplace");
    const arr = userPlaceList.filter((val: any) => {
      return val.placeId === placeId;
    }) as any;
    if (isNull(arr) === true) {
      return "";
    } else {
      return arr[0].placeName;
    }
  } catch (e) {
    return "";
  }
}

/**
 * 存放返回类型
 */
function setReturnType(nodeId: string, val: number) {
  try {
    /**设置默认*/
    if (val === 0) {
      setItem("session", "returntype", nodeId, 0);
    } else {
      /**如果提交的值比存储的值要大则存储*/
      let type = getItem("session", "returntype", nodeId);
      if (isNull(type)) {
        type = 0;
      }
      if (val > type) {
        setItem("session", "returntype", nodeId, val);
      }
    }
  } catch (e) {
    return 0;
  }
}
/**
 * 获取返回类型
 */
function getReturnType(nodeId: string) {
  try {
    return getItem("session", "returntype", nodeId);
  } catch (e) {
    return 9;
  }
}
/**
 * 存放head当前时间。
 */
function setHeadCurrentTime(nodeId: string, val: any) {
  try {
    setItem("session", "headcurrenttime", nodeId, val);
  } catch (e) {
    return 0;
  }
}
/**
 * 获取head当前时间。
 */
function getHeadCurrentTime(nodeId: string) {
  try {
    return getItem("session", "headcurrenttime", nodeId);
  } catch (e) {
    return 9;
  }
}

/**
 * 存放操作时间
 */
function setOperateTime(nodeId: string, val: any) {
  try {
    setItem("session", "operatetime", nodeId, val);
  } catch (e) {
    return 0;
  }
}
/**
 * 获取操作时间
 */
function getOperateTime(nodeId: string) {
  try {
    return getItem("session", "operatetime", nodeId);
  } catch (e) {
    return 9;
  }
}

/**
 * 存放录入锁定--好像不用了。
 */
function setInputLock(nodeId: string, val: any) {
  try {
    setItem("session", "inputlock", nodeId, val);
  } catch (e) {
    return 0;
  }
}
/**
 * 获取返回类型--好像不用了。
 */
function getInputLock(nodeId: string) {
  try {
    return getItem("session", "inputlock", nodeId);
  } catch (e) {
    return 9;
  }
}


/**
 * 存放-参数分类
 */
function setParamInfoCategory(val: any) {
  try {
    setItem("session", "basic", "paraminfocategory", val);
  } catch (e) {
    return "";
  }
}
/**
 * 获取-参数分类
 */
function getParamInfoCategoryByQuery(startPlaceId: string, arrivePlaceId: string, placeType: number, categoryType: number) {
  try {
    let arr;
    if (startPlaceId === '-1' || arrivePlaceId === '-1'|| placeType === -1) {
      arr = '';
      return;
    }
    const list = getItem('session', 'basic', 'paraminfocategory');

    if (placeType === 1) {
      arr = list.filter((val: any) => { return val.placeId === startPlaceId && val.infoCategoryType === categoryType }) as any;
    }
    else {
      arr = list.filter((val: any) => { return val.placeId === arrivePlaceId && val.infoCategoryType === categoryType }) as any;
    }
    return arr;
  }
  catch (e) {
    return '';
  }
}



/**
 * 存放-菜单打开的状态
 */
function setNewOpenNode(nodeId: string, val: any) {
  try {
    setItem("session", "newopen", nodeId, val);
  } catch (e) {
    return "";
  }
}
/**
 * 获取-菜单打开的状态
 */
function getNewOpenNode(nodeId: string) {
  try {
    return getItem("session", "newopen", nodeId);
  } catch (e) {
    return "";
  }
}

/**
 * 存放-控件内容
 */
function setControlContent(corpNameAndClass:string, val: any) {
  try {
    if (!(isNull(corpNameAndClass) || isNull(val))) {
      setItem("session","controlset", corpNameAndClass, val);
    }
  } catch (e) {
    return "";
  }
}
/**
 * 获取-控件内容
 */
function getControlContent(corpNameAndClass:string) {
  try {
    return getItem("session","controlset",corpNameAndClass);
  } catch (e) {
    return "";
  }
}

/**
 * 存放-地区
 */
function setDistrict(version: number, type: string, val: any) {
  try {
    if (!(isNull(type) || isNull(val))) {
      setItem("session", "district", "version", version);
      setItem("session", "district", type, val);
    }
  } catch (e) {
    return;
  }
}
/**
 * 获取-地区
 */
function getDistrict(type: string) {
  try {
    return getItem("session", "district", type);
  } catch (e) {
    return;
  }
}

/**
 * 存放-公司名称
 */
function setCorpName(val: any) {
  try {
    if (!isNull(val)) {
      setItem("session","basic", "corpname", val);
    }
  } catch (e) {
    return;
  }
}
/**
 * 获取-公司名称
 */
function getCorpName() {
  try {
    return getItem("session", "basic", "corpname");
  } catch (e) {
    return;
  }
}

/**
 * 存放-蓝牙设备id
 */
function setBluetoothDeviceId(val: any) {
  try {
    if (!isNull(val)) {
      setItem("session","basic", "bluetooth", val);
    }
  } catch (e) {
    return;
  }
}
/**
 * 获取-蓝牙设备id
 */
function getBluetoothDeviceId() {
  try {
    return getItem("session", "basic", "bluetooth");
  } catch (e) {
    return;
  }
}


/**
 * 存放-子栏目路由
 */
function setSonNodeRoutePath(parentNodeId:any,val: any) {
  try {
    if (!isNull(val)) {
      setItem("session","sonnoderoutepath", parentNodeId, val);
    }
  } catch (e) {
    return;
  }
}
/**
 * 获取-子栏目路由
 */
function getSonNodeRoutePath(parentNodeId:any) {
  try {
    return getItem("session", "sonnoderoutepath",parentNodeId);
  } catch (e) {
    return '';
  }
}

/**
 * 导出
 */
export default {
  setItem,
  //getStroage,
  getItem,
  clearItem,
  clearNamespace,
  clearAll,

  getSerialNo,
  setNodeId,
  getNodeId,
  clearNodeId,
  clearUserRight,
  getPageNode,

  getPageNodePath,
  setPageNodePath,

  setParentNodePath,
  getParentNodePath,

  getUserRight,
  setUserRight,

  getOperateRight,

  inspectUserRight,

  getPlaceBindByClassAndLongFlag,
  getPlaceBindByClassAndLongFlagNoPlease,

  getPlaceBindStart,
  getPlaceBindConsignmentArrive,
  getPlaceBindLongArrive,
  
  getMemberPlace,

  getUserOperatePlace,
  getUserOperatePlaceNoPlease,
  getUserOperatePlaceMustPlease,
  
  getPlaceRegion,
  getPlaceName,

  setReturnType,
  getReturnType,

  setHeadCurrentTime,
  getHeadCurrentTime,

  setOperateTime,
  getOperateTime,

  setInputLock,
  getInputLock,

  setParamInfoCategory,
  getParamInfoCategoryByQuery,

  setNewOpenNode,
  getNewOpenNode,

  setControlContent,
  getControlContent,

  setDistrict,
  getDistrict,

  setCorpName,
  getCorpName,

  setSonNodeRoutePath,
  getSonNodeRoutePath,
};